export default __webpack_public_path__ + "static/media/pulse_white_hor.962e94c7.svg";